import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            最新上架
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            每日更新动态，第一时间掌握最新上线内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
            {updateItems.map((item) => (
              <div key={item.id} className="relative pb-6 last:pb-0">
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-md text-xs font-bold bg-primary-500 text-white whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                    <span className="text-xs text-accent-600 font-medium">新上线</span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}